import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import earth from "../Assets/Background.png";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
function Slider() {
  return (
     <>
      <Swiper
        spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
  <SwiperSlide>

                  <div className="banner ">
                  <div className='overlay2'>

        <h2>
          Transforming Ideas Into Reality with <span>Semicave semiconductor Solutions</span>
        </h2>
        <button>Lets Talk</button>
        <img src={earth} />
                  </div>

      </div>
        </SwiperSlide>
               <SwiperSlide>

                  <div className="banner banner2">
                  <div className='overlay2'>

        <h2>
          Engineering Tomorrow, Today <span>Your Partner in Semiconductor Innovation</span>
        </h2>
        <button>Lets Talk</button>
        <img src={earth} />
                  </div>

      </div>
        </SwiperSlide>
           <SwiperSlide>
               
                  <div className="banner banner3">
                  <div className='overlay2'>

        <h2>
          One Roof. Infinite Possibilities <span>End-to-End Product Engineering Solutions</span>
        </h2>
        <button>Lets Talk</button>
        <img src={earth} />
      </div>
      </div>
        </SwiperSlide>
      </Swiper>
      
    </>
  )
}

export default Slider